<template>
  <div class="details">
    <a-spin :spinning="infoSpinning">
      <div
        class="card plr-16"
        style="padding: 0px 36px; border-top-left-radius: 15px;
  border-top-right-radius: 15px;"
      >
        <comment
          whole
          :commentData="commentData"
        >
          <div
            slot="more"
            class="flex"
            style="margin-left: auto;"
          >
            <p class="d-flex ml-4 cp">
              <svg-icon iconClass="browse"></svg-icon>
              <span class="font-12 ml-1">{{ commentData.watchNum || 0 }}</span>
            </p>
            <p
              class="d-flex ml-4 cp"
              @click="addIsCancel"
            >
              <svg-icon :iconClass="isZan ? 'like_active' : 'like_default'"></svg-icon>
              <span class="font-12 ml-1">{{ zanNum || 0 }}</span>
            </p>
            <p class="d-flex ml-4 cp">
              <svg-icon iconClass="comment_default"></svg-icon>
              <span class="font-12 ml-1">{{ commentData.commentNum || '回复' }}</span>
            </p>
          </div>
        </comment>
        <div class="mt-6 flex pb-3">
          <a-avatar
            :size="56"
            :src="userData.headImgUrl"
          />
          <div class="flex-1 ml-7">
            <a-textarea
              :rows="6"
              v-model="content"
            ></a-textarea>
            <a-button
              type="primary"
              @click="replyTheme"
            >发表提问</a-button>
          </div>
        </div>
        <!-- <div style="display: flex;justify-content: center;">
          <div class="like">
            <img
              @click="addIsCancel"
              :src="isZan ? yetZan : dianzan2"
              alt=""
              style="width: 46px;margin-bottom: 12px;"
            />
            <span>{{ zanNum || 0 }}点赞</span>
          </div>
          <div class="like">
            <img @click="visible = true" :src="replyLz" alt="" style="width: 46px;margin-bottom: 12px;" />
            <span>回复楼主</span>
          </div>
        </div> -->
      </div>
      <!-- <div class="card" style="padding: 22px 15px;overflow: hidden;">
        <h3>回复楼主</h3>
        <a-textarea :rows="10" v-model="content"></a-textarea>
        <a-button type="primary" @click="replyTheme">回复</a-button>
      </div> -->
      <!-- <div class="card" style="padding: 22px 36px;overflow: hidden;" v-if="teacherCommentList.length">
        <h3>老师回答</h3>
        <div>
          <comment
            :ref="'comment' + item.id"
            v-for="item in teacherCommentList"
            :info="false"
            :key="item.id"
            :comment-data="item"
            :themeUserId="commentData.userId"
            :opers="teacherOpers(item)"
            @onLike="likeTread('1', $event)"
            @onTread="likeTread('2', $event)"
            @onAdopt="onAdopt"
            @onReply="replyComment"
          />
        </div>
      </div> -->
      <div
        class="card"
        style="padding: 22px 36px;overflow: hidden; border-bottom-left-radius: 15px;
  border-bottom-right-radius: 15px;"
      >
        <a-tabs
          v-model="tab"
          :tabBarStyle="{
            color: '#84878D',
            marginBottom: '0',
            borderBottom: 'none'
          }"
        >
          <a-tab-pane
            tab="老师回复"
            key="1"
          >
            <template v-if="teacherCommentList.length">
              <comment
                :ref="'comment' + item.id"
                v-for="item in teacherCommentList"
                :info="false"
                :key="item.id"
                :comment-data="item"
                :themeUserId="commentData.userId"
                :opers="teacherOpers(item)"
                @onLike="likeTread('1', $event)"
                @onTread="likeTread('2', $event)"
                @onAdopt="onAdopt"
                @onReply="replyComment"
              />
            </template>
            <template v-else>
              <z-pagination
                type="C"
                desc="还没有回复的内容~"
                :spinning="false"
                :total="0"
                @loadData="false"
              >
              </z-pagination>
            </template>
          </a-tab-pane>
          <a-tab-pane
            :tab="`全部回复（${total || 0}）`"
            key="2"
          >
            <z-pagination
              type="C"
              desc="还没有回复的内容~"
              :spinning="spinning"
              :total="total"
              @loadData="loadData"
            >
              <comment
                :ref="'comment' + item.id"
                v-for="item in replyList"
                :key="item.id"
                :info="false"
                :comment-data="item"
                :opers="['like', 'tread', 'reply', 'del']"
                @onLike="likeTread('1', $event)"
                @onTread="likeTread('2', $event)"
                @onReply="replyComment"
                @onDelete="deleteCommentAsync(item)"
              ></comment>
            </z-pagination>
          </a-tab-pane>
        </a-tabs>
        <!-- <h3>全部回复<span v-show="total">（{{ total }}）</span></h3> -->
        <!-- <z-pagination type="C" desc="还没有回复的内容~" :spinning="spinning" :total="total" @loadData="loadData">
          <comment
            :ref="'comment' + item.id"
            v-for="item in replyList"
            :key="item.id"
            :info="false"
            :comment-data="item"
            :opers="['like', 'tread', 'reply', 'del']"
            @onLike="likeTread('1', $event)"
            @onTread="likeTread('2', $event)"
            @onReply="replyComment"
            @onDelete="deleteCommentAsync(item)"
          ></comment>
        </z-pagination> -->
      </div>
    </a-spin>
    <!-- <z-modal :width="434" title="回复" :visible.sync="visible" :border="false" @submit="replyTheme">
      <a-textarea :rows="10" v-model="content"></a-textarea>
    </z-modal> -->
  </div>
</template>
<script>
// import zBreadcrumb from '@/components/tools/Breadcrumb.vue'
import zPagination from '@/components/ZPagination'
import comment from '../components/Comment'
import zModal from '@/components/ZModal'
import dianzan2 from '@/assets/icons/dianzan2.png'
import yetZan from '@/assets/icons/yetZan.png'
import replyLz from '@/assets/icons/replyLz.png'
import {
  findTheme,
  addWatchNum,
  isThemeZan,
  cancelZan,
  addZan,
  findStudentComment,
  findTeacherComment,
  addComment,
  deleteComment,
  opComment,
  adoptComment
} from '@/api/myQa'
export default {
  name: '',
  data () {
    return {
      replayLock: false,
      tab: '1',
      dianzan2,
      yetZan,
      replyLz,
      current: 1,
      content: '',
      visible: false,
      commentData: {},
      infoSpinning: false, // 贴子内容
      isZan: false, // 是否点赞
      zanNum: 0, // 点赞数
      id: null, // 贴子id
      params: {
        limit: 10,
        page: 0
      },
      replyList: [],
      replyListAll: [],
      teacherCommentList: [],
      total: 0,
      spinning: false
    }
  },
  computed: {
    userData () {
      const data = this.$store.getters.getUserData(['id', 'isTeacher', 'headImgUrl'])
      return data
    },
    teacherOpers () {
      const { id: userId } = this.userData
      return function ({ adopt }) {
        if (userId === this.commentData.userId && adopt !== 'Y') {
          return ['like', 'tread', 'reply', 'adopt']
        }
        return ['like', 'tread', 'reply']
      }
    }
  },
  components: {
    zPagination,
    comment,
    zModal
  },
  created () {
    this.id = this.$route.query.id
    this.findThemeAysnc(this.$route.query.id)
    this.addWatchNumASync(this.$route.query.id)
    this.isThemeZanAsync(this.$route.query.id)
    this.findStudentCommentAsync({
      ...this.params,
      themeId: this.$route.query.id
    })
    this.findTeacherCommentAsync(this.$route.query.id)
  },
  methods: {
    loadData (val) {
      this.params.page = parseInt(val) - 1
      const { page, limit } = this.params
      this.replyList = this.replyListAll.slice(page * limit, page * limit + limit)
      // this.findStudentCommentAsync({
      // ...this.params,
      // themeId: this.id
      // })
    },
    // setReplyList({ page, limit }) {

    // },
    // 采纳回答
    async onAdopt ({ id, userId }) {
      try {
        const { userId: themeCreaterId, id: themeId } = this.commentData
        const res = await adoptComment({
          commentId: id,
          themeCreaterId,
          userId,
          themeId
        })
        console.log('res', res)
        res && this.findTeacherCommentAsync(this.id)
        !res && this.$message.error('采纳失败')
      } catch (error) {
        console.log(error)
      }
    },
    // 点赞/点踩
    async likeTread (state, { id, role, themeId, userId }) {
      try {
        const res = await opComment({
          commentId: id,
          state,
          themeId,
          userId
        })
        if (!res) {
          res && this.$message.error('点赞失败')
          return
        }
        if (role === 't') {
          this.findTeacherCommentAsync(this.id)
        } else {
          this.findStudentCommentAsync({
            ...this.params,
            themeId: this.id
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 删除评论
    async deleteCommentAsync ({ id, themeId, userId }) {
      try {
        const res = await deleteComment({ commentId: id, themeId, userId })
        console.log(res)
        if (res) {
          this.findThemeAysnc(this.id)
          this.findStudentCommentAsync({
            ...this.params,
            themeId: this.id
          })
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 评论回复
    replyComment (ev) {
      console.log(ev) // replyCommentId
      this.addCommentASync({
        ...ev
      })
      // this.visible = true
      // this.replyCommentData = ev
    },
    // 贴子回复
    async replyTheme () {
      if (!this.content) {
        this.$message.error('请输入回复内容')
        return
      }
      if (this.replayLock) return
      this.replayLock = true
      await this.addCommentASync({
        content: this.content,
        themeId: this.id,
        role: this.userData.isTeacher
      })
      this.replayLock = false
      // if (this.replyCommentData) {
      //   this.addCommentASync({
      //     ...this.replyCommentData,
      //     content: this.content
      //   })
      //   return
      // }
      // this.addCommentASync({
      //   content: this.content,
      //   themeId: this.id,
      //   role: this.userData.isTeacher
      // })
    },
    // 获取贴子详情
    async findThemeAysnc (id) {
      try {
        this.infoSpinning = true
        const res = await findTheme(id)
        this.commentData = res
        this.zanNum = res.zanNum
      } catch (error) {
        console.log(error)
      } finally {
        this.infoSpinning = false
      }
    },
    async addIsCancel () {
      try {
        // 以点赞 —— 取消点赞
        this.infoSpinning = true
        if (this.isZan) {
          const res = await cancelZan(this.id)
          res && this.zanNum--
        } else {
          const res = await addZan(this.id)
          res && this.zanNum++
        }
        // this.findThemeAysnc(this.id)
        // this.isThemeZanAsync(this.$route.query.id)
        this.isZan = !this.isZan
      } catch (error) {
        console.log(error)
      } finally {
        this.infoSpinning = false
      }
    },
    // 增加贴子观看数
    async addWatchNumASync (id) {
      try {
        await addWatchNum(id)
      } catch (error) {
        console.log(error)
      }
    },
    // 是否以点赞
    async isThemeZanAsync (id) {
      try {
        const res = await isThemeZan(id)
        this.isZan = typeof res === 'boolean' ? res : res.data
      } catch (error) {
        console.log(error)
      }
    },
    // 获取贴子下学生的回复
    async findStudentCommentAsync (data) {
      try {
        this.spinning = true
        const { list, commentNum } = await findStudentComment(data)
        if (list && list.length > data.limit) {
          this.replyList = list.slice(data.page, data.limit)
        } else {
          this.replyList = list
        }
        this.replyListAll = list
        this.total = commentNum
      } catch (error) {
        console.log(error)
      } finally {
        this.spinning = false
      }
    },
    // 获取贴子下老师的回复
    async findTeacherCommentAsync (themeId) {
      try {
        const res = await findTeacherComment({
          themeId
        })
        this.teacherCommentList = res
      } catch (error) {
        console.log(error)
      }
    },
    // 回复贴子/评论
    async addCommentASync ({ role, ...data }) {
      try {
        this.$message.loading({ content: 'Loading...', key: 'reply' })
        const res = await addComment(data)
        res &&
          this.$message.success({
            content: '回复成功!',
            key: 'reply'
          })
        this.content = ''
        data.replyCommentId && this.$refs['comment' + data.replyCommentId][0].remove()
        // this.visible = false
        // console.log()
        // if (role === 't' || role === true) {
        // } else {
        // }
        this.findThemeAysnc(this.id)
        this.findTeacherCommentAsync(this.id)
        this.findStudentCommentAsync({
          ...this.params,
          themeId: this.id
        })
        return true
      } catch (error) {
        console.log(error)
        return false
      } finally {
        this.replyCommentData && (this.replyCommentData = null)
      }
    }
  }
}
</script>
<style lang="less" scoped>
.plr-16 {
  padding: 0 16px;
}
h3 {
  font-size: 16px;
  font-weight: bold;
}
.details {
  // width: 1200px;
  // width: 100%;
  width: auto;
  height: 100%;
  // margin: 0 auto;
  margin: -15px;
  background-color: #f5f6fa;
}
.card {
  background-color: #fff;
  // border-radius: 15px;
  .like {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 32px 35px;
    color: #5e668d;
    img {
      cursor: pointer;
    }
  }
  .ant-btn {
    margin-top: 10px;
    float: right;
    height: 32px;
    line-height: 32px;
    background: #4b7dfd;
    border-radius: 4px;
  }
  .ant-pagination {
    margin-top: 18px;
    text-align: center;
  }
  // .ant-input {
  //   margin: 24px 0;
  // }
}
.ant-input {
  padding: 10px;
  // background: #f5f6fa;
  border-radius: 4px;
  // border: 1px solid #4B7DFD;
}
</style>
